import axios from 'axios'
import Cookies from 'js-cookie'
import { useMemo } from 'react'
import { constants } from 'src/lib/utils/constants'
import { apiURI } from 'src/lib/utils/constants'
import { SWRConfiguration } from 'swr'
import useSWR from 'swr'
import { staticOptions } from '../core/api-client'

export const authEngineFetcher: SWRConfiguration['fetcher'] = async (url: string) => {
  const response = await axios.get(url, {
    baseURL: apiURI.AUTH_ENGINE,
    headers: { Authorization: Cookies.get(constants.AUTH_COOKIE_CLIENT) ?? '' }
  })
  return response.data
}

export interface ShareAccount {
  email: string
  /** Comma-joined role names (e.g. "Admin"). Empty when the account has no roles. */
  role: string
}

export const useShareEmail = () => {
  const {
    data: merchantAccounts,
    isValidating,
    error: emailError
  } = useSWR('/merchant-account?offset=1&limit=50', authEngineFetcher, staticOptions)

  const accounts = useMemo<ShareAccount[]>(() => {
    if (!merchantAccounts) return []
    return merchantAccounts.data
      .filter((account: any) => account.invite_accepted && account.oid)
      .map((account: any) => ({
        email: account.oid,
        role: (account.roles ?? []).map((r: any) => r.name).filter(Boolean).join(', ')
      }))
  }, [merchantAccounts])

  const emails = useMemo(() => accounts.map(account => account.email), [accounts])

  return {
    emails,
    accounts,
    isValidating,
    emailError
  }
}
